export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Medium-832f4f38cf8caa911155ddffacd0be40.woff";